import { render, staticRenderFns } from "./ContactPersonList.vue?vue&type=template&id=fe2fa0c6&"
import script from "./ContactPersonList.vue?vue&type=script&lang=ts&"
export * from "./ContactPersonList.vue?vue&type=script&lang=ts&"
import style0 from "./ContactPersonList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports